package link.erpango.quip.domain.entities

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class DSparePartDocument(
    @SerialName("id")
    val id: Long = 0, // Backend ID
    @Transient
    val localId: Long? = null, // Database PK
    @SerialName("spare_part_id")
    val sparePartId: Long, // Backend ID of Spare Part
    @Transient
    val localSparePartId: Long? = null, // Database PK of Spare Part
    @SerialName("vehicle_vin")
    val vehicleVin: String,
    @SerialName("name")
    val name: String,
    @SerialName("file")
    val filePath: String = "", // Server URL or local path
    @SerialName("file_type")
    val fileType: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String? = null,
    @SerialName("size_mb")
    val sizeMb: Double = 0.0,
    @SerialName("file_content")
    val fileContentBase64: String? = null, // Transient, used for upload
    @SerialName("file_base64")
    val fileBase64: String? = null // Content from server
)
